import React from "react";
import SuperAdminDepartments from "../superadmin/organization/DepartmentsPage";

const DepartmentsPage = () => {
    return <SuperAdminDepartments />;
};

export default DepartmentsPage;
